import { useEffect, useState } from 'react'

/**
 * The id of the part being read: the last element matching `selector` inside
 * `ref` whose top has passed under the header. Checked once per frame while
 * scrolling, and again whenever `key` changes (say, a filter re-renders the list).
 */
export function useScrollSpy(ref, selector, key) {
  const [active, setActive] = useState(null)

  useEffect(() => {
    let frame = 0
    const spy = () => {
      frame = 0
      let current = null
      for (const el of ref.current.querySelectorAll(selector)) {
        if (el.getBoundingClientRect().top < 150) current = el.id
      }
      setActive(current)
    }
    const schedule = () => {
      frame ||= requestAnimationFrame(spy)
    }
    spy()
    window.addEventListener('scroll', schedule, { passive: true })
    return () => {
      cancelAnimationFrame(frame)
      window.removeEventListener('scroll', schedule)
    }
  }, [ref, selector, key])

  return active
}
